import { Injectable } from '@angular/core';
import { MessageTypeE } from '@enums/message.enum';
import { MessageGroupI } from '@interfaces/group.interface';
import { PageI } from '@interfaces/page.interface';
import { ComponentStore } from '@ngrx/component-store';
import { MessageTypeT } from '@omnitypes/message.type';
import { Observable, map } from 'rxjs';

export interface MediaMessagesStoreState {
  messages: { [groupId: string]: PageI<MessageGroupI> };
}

@Injectable({
  providedIn: 'root',
})
export class MediaMessagesGroupStoreService extends ComponentStore<MediaMessagesStoreState> {
  public messages$: Observable<{ [id: string]: PageI<MessageGroupI> }> = this.select((state) => state.messages);

  constructor() {
    super({
      messages: {},
    });
  }

  public getMessagesByGroupId(groupId: string): Observable<PageI<MessageGroupI>> {
    return this.messages$.pipe(map((messages) => messages[groupId]));
  }

  public async populateStore(groupId: string, page: PageI<MessageGroupI>) {
    this.setState((state) => ({
      ...state,
      messages: {
        ...state.messages,
        [groupId]: page,
      },
    }));
  }

  public unshiftMessagesByGroupId(groupId: string, page: PageI<MessageGroupI>) {
    this.setState((state) => ({
      ...state,
      messages: {
        ...state.messages,
        [groupId]: {
          data: [...page.data, ...state.messages[groupId].data],
          meta: page.meta,
        },
      },
    }));
  }

  public pushMessageGroupIfIsMedia(groupId: string, message: MessageGroupI) {
    if (['audio', 'video', 'image'].includes(this.getMessageType(message))) {
      this.setState((state) => {
        if (state.messages[groupId].data.filter((existentMessage) => existentMessage._id == message._id).length == 0) {
          return {
            ...state,
            messages: {
              ...state.messages,
              [groupId]: {
                ...state.messages[groupId],
                data: [...state.messages[groupId].data, message],
              },
            },
          };
        }
        return state;
      });
    }
  }

  public pushMessagesByGroupId(groupId: string, page: PageI<MessageGroupI>) {
    this.setState((state) => ({
      ...state,
      messages: {
        ...state.messages,
        [groupId]: {
          data: [...state.messages[groupId].data, ...page.data],
          meta: page.meta,
        },
      },
    }));
  }

  public getMessageType(message?: MessageGroupI): MessageTypeE {
    if (['audio', 'video', 'image'].includes(message?.type || '')) {
      return message?.type as MessageTypeE;
    }

    if (message?.content?.file) {
      let fileName = message.content.file?.fileName || message.content.file?.Key;
      let format = fileName?.split('.').pop()?.toLowerCase();

      if (['mp4', 'mov', 'avi'].includes(format!)) {
        return MessageTypeE.VIDEO;
      }

      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(format!)) {
        return MessageTypeE.IMAGE;
      }

      if (['wav', 'aac', 'ogg', 'mp3', 'm4a'].includes(format!)) {
        return MessageTypeE.AUDIO;
      }
    }

    return message?.type ?? MessageTypeE.TEXT;
  }
}
